import React, { useState } from 'react';

import { ModalComponent } from 'baseComponents/ModalComponent';

import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { LinkComponent } from 'baseComponents/LinkComponent';
import { useGetPurchaseHistoryStatus } from 'hooks/useGetPaymentHistoryStatus';
import './purchaseHistoryDetailsModal.scss';
import { Spin } from 'antd';
interface Props {
  id: number;
  status: string;
}

export const PurchaseHistoryDetailsModal: React.FC<Props> = (props) => {
  const [open, setOpen] = useState(false);
  const { data, isPending, mutate } = useGetPurchaseHistoryStatus(props.id);
  return (
    <>
      <LinkComponent
        label={props.status.toLowerCase()}
        className='purchase-history-details-modal-trigger'
        onClick={() => {
          mutate();
          setOpen(true);
        }}
      />
      <ModalComponent
        title={`Purchase History Details`}
        close={() => setOpen(false)}
        open={open}
      >
        <div className='purchase-history-details-modal'>
          {isPending ? (
            <Spin spinning size='large' />
          ) : (
            <pre>{JSON.stringify(data, null, 4)}</pre>
          )}
        </div>
        <ButtonComponent
          appereance='secondary'
          size='middle'
          onClick={() => setOpen(false)}
          label='Close'
          fullWidth
        />
      </ModalComponent>
    </>
  );
};
